import { render, staticRenderFns } from "./ProductVariantListItem.vue?vue&type=template&id=0010ad05&scoped=true&"
import script from "./ProductVariantListItem.vue?vue&type=script&lang=js&"
export * from "./ProductVariantListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantListItem.vue?vue&type=style&index=0&id=0010ad05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0010ad05",
  null
  
)

export default component.exports